import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderMenuComponent } from './header-menu.component';
import { LangSwitcherModule } from '../lang-switcher/lang-switcher.module';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { MatRippleModule } from '@angular/material/core';
import { NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
    declarations: [HeaderMenuComponent],
    imports: [
        CommonModule,
        LangSwitcherModule,
        TranslateModule,
        RouterModule,
        MatRippleModule,
        NgbPopoverModule
    ],
    exports: [HeaderMenuComponent],
})
export class HeaderMenuModule {}
